import { useGetBookingInfoMutation } from '@/store/checkout/checkout.api';
import { useEvent, useBooking } from '@/store';

export default function useGetOrderInfo() {
  const [getBookingInfo, orderInfo] = useGetBookingInfoMutation();
  const { booking, setOrderInfo } = useBooking();
  const {
    event: {
      event: { id },
    },
  } = useEvent();

  const getOrderInfo = async () => {
    const body = {
      event_id: id,
      booking_number: booking.order,
    };
    try {
      const response = await getBookingInfo(body);
      setOrderInfo(response.data);
      return response;
    } catch {
      return false;
    }
  };

  return {
    getOrderInfo,
    orderInfo,
    booking,
  };
}
